import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { PropTypes } from "prop-types";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import DraggableItem from "../DraggableItem/DraggableItem";

const useStyles = makeStyles(theme => ({
  buttonRoot: {
    display: "flex",
    flexDirection: "column",
    minWidth: "unset",
    width: "100%",
    padding: theme.spacing(0.75, 1)
  }
}));

const DraggableItemsBox = ({
  buttons,
  header,
  onIsDraggingChange,
  onButtonClick
}) => {
  const theme = useTheme();
  const { buttonLabel, buttonRoot } = useStyles();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      bgcolor={theme.palette.action.hover}
      pt={3}
      pb={2}
      px={1.5}
      maxWidth={145}
      width={145}
    >
      <Typography variant="subtitle1">{header}</Typography>
      <Box
        display="flex"
        pt={2}
        flexWrap="wrap"
        width="100%"
        justifyContent="center"
      >
        {buttons.map((button, index) => (
          <Box flexBasis={"50%"} pb={1.25} key={index}>
            {button.draggable ? (
              <DraggableItem
                key={button.text + index}
                buttonText={button.text}
                buttonId={button.id}
                icon={button.icon}
                onIsDraggingChange={onIsDraggingChange}
              />
            ) : (
              <Button
                color="primary"
                classes={{ label: buttonLabel, root: buttonRoot }}
                onClick={() => onButtonClick({ id: button.id })}
              >
                {button.icon}
                <Typography
                  color="primary"
                  sx={{ fontSize: "0.625rem", pt: 0.5 }}
                >
                  {button.text}
                </Typography>
              </Button>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default DraggableItemsBox;

DraggableItemsBox.propTypes = {
  buttons: PropTypes.shape({
    text: PropTypes.string,
    // If false, button will be clickable rather than draggable
    draggable: PropTypes.bool,
    id: PropTypes.string,
    icon: PropTypes.node
  })
};
